import { refusalProse } from '@backrs_ui/grow-ui/src/components/InstitutionWrite/refusalProse';
import {
  CODE_NEEDS_MINT_LINE,
  decodeErrorEnvelope,
  INVITE_CODE_TAKEN,
  MINT_LINE_AMBIGUOUS,
} from '@backrs_ui/grow-ui/src/redux/institutionAdmin';

import { codeStrings, institutionAdminStrings } from './institutionAdminWriteMessages';

/**
 * Keyed on the code, not on the door: both writes refuse this way for the same
 * reason, and the remedy — choose a line — is the same for either.
 */
export const writeProse = (error: unknown) => {
  const code = decodeErrorEnvelope(error)?.code;

  if (code === MINT_LINE_AMBIGUOUS) return institutionAdminStrings.mintLineAmbiguous;
  if (code === INVITE_CODE_TAKEN) return codeStrings.mint.taken;
  if (code === CODE_NEEDS_MINT_LINE) return institutionAdminStrings.codeNeedsMintLine;

  return refusalProse(error);
};

/** The server explains these arms itself; the surface only owns the wording it minted. */
export const landedProse = (error: unknown, fallback: string) => refusalProse(error) ?? fallback;
